import store from "../store/index";
export default {
  default: 0,
  list: {
    "/user/upload": 1,
    "/user/center": 1,
    "/user/cloud": 1,
  },
  hasPremiss(path) {
    let auth = store.state.user.auth || 0;
    let reuiredAuth = this.list[path] || this.default;
    return auth >= reuiredAuth;
  }
};
